<style>
   label{
       font-weight: unset;
   } 
</style>
<template>
    <div> 
        <!-- Grade da duplicata INICIO -->
    <div class="hl" style="z-index: 134; left: 0; width: 720px; position: absolute; top: 70px; height: 1px">
    </div>
    <div class="hl" style="z-index: 135; left: 0; width: 720px; position: absolute; top: 94px; height: 1px">
    </div>
    <div class="hl" style="z-index: 136; left: 0; width: 720px; position: absolute; top: 118px; height: 1px">
    </div>
    <div class="hl" style="z-index: 137; left: 0; width: 720px; position: absolute; top: 142px; height: 1px">
    </div>
    <div class="hl" style="z-index: 138; left: 0; width: 720px; position: absolute; top: 166px; height: 1px">
    </div>
    <div class="hl" style="z-index: 139; left: 500px; width: 220px; position: absolute; top: 190px; height: 1px">
    </div>
    <div class="hl" style="z-index: 140; left: 0; width: 720px; position: absolute; top: 289px; height: 1px">
    </div>
    <div class="hl" style="z-index: 141; left: 0; width: 720px; position: absolute; top: 334px; height: 1px">
    </div>
    <div class="hl_riscado" style="z-index: 142; left: 0; width: 720px; position: absolute; top: 366px; height: 1px">
    </div>
    <div class="hl" style="z-index: 143; left: 0; width: 720px; position: absolute; top: 415px; height: 1px">
    </div>
    <div class="hl" style="z-index: 144; left: 0; width: 720px; position: absolute; top: 438px; height: 1px">
    </div>
    <div class="hl" style="z-index: 145; left: 0; width: 720px; position: absolute; top: 462px; height: 1px">
    </div>
    <div class="hl" style="z-index: 146; left: 0; width: 720px; position: absolute; top: 486px; height: 1px">
    </div>
    <div class="hl" style="z-index: 147; left: 0; width: 720px; position: absolute; top: 510px; height: 1px">
    </div>
    <div class="hl" style="z-index: 148; left: 498px; width: 222px; position: absolute; top: 534px; height: 1px">
    </div>
    <div class="hl" style="z-index: 149; left: 0; width: 720px; position: absolute; top: 630px; height: 1px">
    </div>
    <div class="hl" style="z-index: 152; left: 498px; width: 222px; position: absolute; top: 214px; height: 1px">
    </div>
    <div class="hl" style="z-index: 153; left: 498px; width: 222px; position: absolute; top: 238px; height: 1px">
    </div>
    <div class="hl" style="z-index: 154; left: 498px; width: 222px; position: absolute; top: 262px; height: 1px">
    </div>
    <div class="hl" style="z-index: 155; left: 498px; width: 222px; position: absolute; top: 558px; height: 1px">
    </div>
    <div class="hl" style="z-index: 156; left: 498px; width: 222px; position: absolute; top: 582px; height: 1px">
    </div>
    <div class="hl" style="z-index: 157; left: 498px; width: 222px; position: absolute; top: 606px; height: 1px">
    </div>
    <div class="hl" style="z-index: 150; left: 0; width: 720px; position: absolute; top: 673px; height: 1px">
    </div>
    <div class="hl_riscado" style="z-index: 151; left: 0; width: 720px; position: absolute; top: 773px; height: 1px">
    </div>
    <div style="left: 498px; z-index: 159; position: absolute; top: 71px; height: 218px; width: 1px;"
        class="vl">
    </div>
    <div style="left: 498px; z-index: 160; position: absolute; top: 416px; height: 214px; width: 1px;"
        class="vl">
    </div>
    <div class="vl" style="z-index: 161; left: 210px; width: 1px; position: absolute; top: 46px; height: 25px">
    </div>
    <div class="vl" style="z-index: 162; left: 272px; width: 1px; position: absolute; top: 46px; height: 25px">
    </div>
    <div class="vl" style="z-index: 161; left: 210px; width: 1px; position: absolute; top: 390px; height: 25px">
    </div>
    <div class="vl" style="z-index: 162; left: 272px; width: 1px; position: absolute; top: 390px; height: 25px">
    </div>
    <div class="vl" style="z-index: 163; left: 110px; width: 1px; position: absolute; top: 118px; height: 24px">
    </div>
    <div class="vl" style="z-index: 164; left: 249px; width: 1px; position: absolute; top: 118px; height: 24px">
    </div>
    <div class="vl" style="z-index: 165; left: 346px; width: 1px; position: absolute; top: 118px; height: 24px">
    </div>
    <div class="vl" style="z-index: 166; left: 418px; width: 1px; position: absolute; top: 118px; height: 24px">
    </div>
    <div class="vl" style="z-index: 167; left: 104px; width: 1px; position: absolute; top: 142px; height: 24px">
    </div>
    <div class="vl" style="z-index: 168; left: 249px; width: 1px; position: absolute; top: 142px; height: 24px">
    </div>
    <div class="vl" style="z-index: 169; left: 177px; width: 1px; position: absolute; top: 142px; height: 24px">
    </div>
    <div class="vl" style="z-index: 170; left: 382px; width: 1px; position: absolute; top: 142px; height: 24px">
    </div>
    <div class="vl" style="z-index: 173; left: 110px; width: 1px; position: absolute; top: 462px; height: 24px">
    </div>
    <div class="vl" style="z-index: 174; left: 249px; width: 1px; position: absolute; top: 462px; height: 24px">
    </div>
    <div class="vl" style="z-index: 175; left: 346px; width: 1px; position: absolute; top: 462px; height: 24px">
    </div>
    <div class="vl" style="z-index: 176; left: 418px; width: 1px; position: absolute; top: 462px; height: 24px">
    </div>
    <div class="vl" style="z-index: 177; left: 382px; width: 1px; position: absolute; top: 486px; height: 24px">
    </div>
    <div class="vl" style="z-index: 178; left: 249px; width: 1px; position: absolute; top: 486px; height: 24px">
    </div>
    <div class="vl" style="z-index: 179; left: 177px; width: 1px; position: absolute; top: 486px; height: 24px">
    </div>
    <div class="vl" style="z-index: 180; left: 104px; width: 1px; position: absolute; top: 486px; height: 24px">
    </div>
    <!-- Grade da duplicata FIM -->
    <span class="Times9" style="z-index: 185; left: 609px; position: absolute; top: 57px">Recibo do 
        <label v-if="bcoCodigo === '399'">Pagador</label>
        <label v-else>Sacado</label></span>
    <span class="Times7" style="z-index: 188; left: 9px; position: absolute; top: 70px">Local de Pagamento </span>
    <span class="Times7" style="z-index: 191; left: 505px; position: absolute; top: 70px">Vencimento até</span>
    <span class="Times7" style="z-index: 193; left: 9px; position: absolute; top: 94px">
        <label>Beneficiario</label></span>
    <span class="Times7" style="z-index: 195; left: 505px; position: absolute; top: 94px">Agência/Código 
        <label>Beneficiario</label></span>
    <span class="Times7" style="z-index: 196; left: 9px; position: absolute; top: 118px">Data do Documento</span>
    <span class="Times7" style="z-index: 199; left: 121px; position: absolute; top: 118px">Nº do Documento</span>
    <span class="Times7" style="z-index: 201; left: 257px; position: absolute; top: 118px">Espécie Doc.</span>
    <span class="Times7" style="z-index: 203; left: 353px; position: absolute; top: 118px">Aceite</span>
    <span class="Times7" style="z-index: 204; left: 425px; position: absolute; top: 118px">Data Proces.</span>
    <span class="Times7" style="z-index: 206; left: 505px; position: absolute; top: 118px">Nosso Número</span>
    <span class="Times7" style="z-index: 209; left: 9px; position: absolute; top: 142px">Uso do Banco</span>
    <span class="Times7" style="z-index: 211; left: 113px; position: absolute; top: 142px">Carteira</span>
    <span class="Times7" style="z-index: 213; left: 185px; position: absolute; top: 142px">Espécie</span>
    <span class="Times7" style="z-index: 215; left: 256px; position: absolute; top: 142px">Quantidade</span>
    <span class="Times7" style="z-index: 216; left: 393px; position: absolute; top: 142px">(x) Valor</span>
    <span class="Times7" style="z-index: 218; left: 505px; position: absolute; top: 142px">(=) Valor do Documento</span>
    &nbsp; &nbsp;
	<span class="Times7" style="z-index: 226; left: 505px; position: absolute; top: 166px">(-) Desconto/Abatimento</span>
    <span class="Times7" style="z-index: 228; left: 9px; position: absolute; top: 167px">Instruções:</span>
    <span class="Times7" style="z-index: 231; left: 505px; position: absolute; top: 190px">(-) Outras Deduções</span>
    <span class="Times7" style="z-index: 232; left: 505px; position: absolute; top: 214px">(+) Mora/Multa</span>
    <span class="Times7" style="z-index: 234; left: 505px; position: absolute; top: 238px">(+) Outros Acrescimos</span>
    <span class="Times7" style="z-index: 236; left: 505px; position: absolute; top: 262px">(=) Valor Cobrado</span>
    <span class="Times7" style="z-index: 239; left: 9px; position: absolute; top: 288px">
        <label v-if="bcoCodigo === '399'">Pagador</label>
        <label v-else>Sacado</label>
        </span>
    <span class="Times7" style="z-index: 242; left: 9px; position: absolute; top: 323px">
        <label v-if="bcoCodigo === '399'">Pagador</label>
        <label v-else>Sacador</label> 
        /Avalista</span>
    <span class="Times7" style="z-index: 189; left: 9px; position: absolute; top: 414px">Local de Pagamento </span>
    <span class="Times7" style="z-index: 190; left: 505px; position: absolute; top: 414px">Vencimento até</span>
    <span class="Times7" style="z-index: 192; left: 9px; position: absolute; top: 438px">
        <label>Beneficiario</label></span>
    <span class="Times7" style="z-index: 194; left: 505px; position: absolute; top: 438px">Agência/Código 
        <label>Beneficiario</label></span>
    <span class="Times7" style="z-index: 197; left: 9px; position: absolute; top: 462px">Data do Documento</span>
    <span class="Times7" style="z-index: 198; left: 121px; position: absolute; top: 462px">Nº do Documento</span>
    <span class="Times7" style="z-index: 200; left: 257px; position: absolute; top: 462px">Espécie Doc.</span>
    <span class="Times7" style="z-index: 202; left: 353px; position: absolute; top: 462px">Aceite</span>
    <span class="Times7" style="z-index: 205; left: 425px; position: absolute; top: 462px">Data Proces.</span>
    <span class="Times7" style="z-index: 207; left: 505px; position: absolute; top: 462px">Nosso Número</span>
    <span class="Times7" style="z-index: 208; left: 9px; position: absolute; top: 486px">Uso do Banco</span>
    <span class="Times7" style="z-index: 210; left: 113px; position: absolute; top: 486px">Carteira</span>
    <span class="Times7" style="z-index: 212; left: 185px; position: absolute; top: 486px">Espécie</span>
    <span class="Times7" style="z-index: 214; left: 256px; position: absolute; top: 486px">Quantidade</span>
    <span class="Times7" style="z-index: 217; left: 393px; position: absolute; top: 486px">(x) Valor</span>
    <span class="Times7" style="z-index: 219; left: 505px; position: absolute; top: 486px">(=) Valor do Documento</span>
    &nbsp; &nbsp;
	<span class="Times7" style="z-index: 227; left: 505px; position: absolute; top: 510px">(-) Desconto/Abatimento</span>
    <span class="Times7" style="z-index: 229; left: 9px; position: absolute; top: 511px">Instruções:</span>
    <span class="Times7" style="z-index: 230; left: 505px; position: absolute; top: 534px">(-) Outras Deduções</span>
    <span class="Times7" style="z-index: 233; left: 505px; position: absolute; top: 558px">(+) Mora/Multa</span>
    <span class="Times7" style="z-index: 235; left: 505px; position: absolute; top: 582px">(+) Outros Acrescimos</span>
    <span class="Times7" style="z-index: 237; left: 505px; position: absolute; top: 606px">(=) Valor Cobrado</span>
    <span class="Times7" style="z-index: 238; left: 9px; position: absolute; top: 630px">
        <label v-if="bcoCodigo === '399'">Pagador</label>
        <label v-else>Sacado</label></span>
    <span class="Times8" style="z-index: 240; left: 467px; position: absolute; top: 675px">Autenticação Mecânica</span>
    <span class="Times7" style="z-index: 241; left: 9px; position: absolute; top: 662px">
        <label v-if="bcoCodigo === '399'">Pagador</label>
        <label v-else>Sacador</label>
        /Avalista</span>
    <span class="Times9" style="z-index: 243; left: 596px; position: absolute; top: 674px">Ficha de Compensação</span>
    <span class="Times9" style="z-index: 244; left: 635px; position: absolute; top: 654px">Código de Baixa</span>
    <!--span class="Times7" style="z-index: 245; left: 9px; position: absolute; top: 107px">Aldo Componentes Eletrônicos Ltda</span>
    <span class="Times7" style="z-index: 246; left: 9px; position: absolute; top: 451px">Aldo Componentes Eletrônicos Ltda</span-->

    <label class="Times7" style="line-height: 7px; z-index: 245; left: 9px; position: absolute; top: 104px; width: 483px;">{{ beneficiarioEndereco }} </label>
    <label class="Times7" style="line-height: 7px; z-index: 246; left: 9px; position: absolute; top: 448px; width: 483px;"> {{ beneficiarioEndereco }} </label>


    <!-- Títulos dos campos FIM -->
    <!-- Labels EM CIMA INICIO -->
    <label style="z-index: 100; left: 9px; position: absolute; top: 54px"
        class="Times11B"> {{ banco }} </label>
    <label class="Times11B" style="z-index: 101; left: 222px; position: absolute; top: 54px"> {{ bcoCodigo }} </label>
    <label class="Times7" style="z-index: 102; left: 9px; position: absolute; top: 83px" v-html="localPgto"></label>
    <label class="Times7" style="z-index: 103; left: 204px; position: absolute; top: 83px"> {{ dupPreferencia }} </label>
    <label class="Times8B" style="z-index: 104; left: 580px; position: absolute; top: 82px"> {{ crrVencimento }} </label>
    <label class="Times7" style="z-index: 105; left: 556px; position: absolute; top: 107px"> {{ bagCodigo }}/{{ bccNumConta }}  </label>
    <label class="Times7B" style="z-index: 106; left: 9px; position: absolute; top: 131px"> {{ crrEmissao }} </label>
    <label class="Times7B" style="z-index: 107; left: 121px; position: absolute; top: 131px"> {{ crcCupomNf }}/{{ crrParcela }} </label>
    <label class="Times7" style="z-index: 108; left: 425px; position: absolute; top: 131px"> {{ crrEmissao }} </label>
    <label class="Times7B" style="z-index: 109; left: 579px; position: absolute; top: 131px"> {{ crrNossoNumero }} </label>
    <label class="Times7" style="z-index: 110; left: 111px; position: absolute; top: 155px"> {{ dupCarteira }} </label>
    <label class="Times7" Style="z-index: 111; left: 184px; position: absolute; top: 155px"> {{ dupMoeda }} </label>
    <label class="Times8B" Style="z-index: 112; left: 602px; position: absolute; top: 154px"> {{ crrValorParcela }} </label>
    <div style="z-index: 248; left: 9px; width: 486px; position: absolute; top: 181px; height: 86px; padding-right: 0; padding-left: 0; padding-bottom: 0; margin: 0; border-top-style: none; padding-top: 0; border-right-style: none; border-left-style: none; border-bottom-style: none;">
        <label class="Times8B" v-html="mensDescricao1"></label> <br>
        <label class="Times8B" v-html="mensDescricao2"></label> <br>
        <label class="Times8" v-html="mensVenc"></label>
    </div>
    <span style="z-index: 250; left: 9px; position: absolute; top: 299px;" class="Times7">
        <label> {{ cliCodigo }} </label>-<label> {{ cliCodigoDv }} </label>
        <label>&nbsp; {{ cliRazaoSocial }} </label></span>
    <label style="z-index: 113; left: 9px; position: absolute; top: 310px"
        class="Times7"> {{ cliEndereco }} </label>
    <label style="z-index: 187; left: 385px; position: absolute; top: 299px"
        class="Times7">CPF/CNPJ: {{ cliCnpj }} </label>
    <span class="Times7" style="z-index: 184; left: 385px; position: absolute; top: 310px">CEP:
		<label> {{ cliCep }} </label>
    </span>
    <label style="z-index: 114; left: 522px; position: absolute; top: 299px"
        class="Times7"> {{ cliCidade }} </label>
    <label style="z-index: 115; left: 522px; position: absolute; top: 310px"
        class="Times7"> {{ estUf }} </label>
    <label class="Times7" style="z-index: 132; left: 258px; position: absolute; top: 131px"> {{ dupEspecie }} </label>
    <label class="Times7" style="z-index: 133; left: 352px; position: absolute; top: 131px">NAO</label>
    &nbsp;
	<!-- Labels Labels EM CIMA FIM -->
    <!-- Labels EM BAIXO INICIO -->
    <label style="z-index: 116; left: 9px; position: absolute; top: 399px"
        class="Times11B"> {{ banco }} </label>
    <label class="Times11B" style="z-index: 117; left: 222px; position: absolute; top: 399px"> {{ bcoCodigo }} </label>
    <label class="Times7" style="z-index: 118; left: 9px; position: absolute; top: 427px" v-html="localPgto"></label>
    <label class="Times7" style="z-index: 119; left: 155px; position: absolute; top: 427px"> {{ dupPreferencia }} </label>
    <label class="Times8B" style="z-index: 120; left: 580px; position: absolute; top: 426px"> {{ crrVencimento }} </label>
    <label class="Times7" style="z-index: 121; left: 556px; position: absolute; top: 451px"> {{ bagCodigo }}/{{ bccNumConta }} </label>
    <label class="Times7B" style="z-index: 122; left: 9px; position: absolute; top: 475px"> {{ crrEmissao }} </label>
    <label class="Times7B" style="z-index: 123; left: 121px; position: absolute; top: 475px"> {{ crcCupomNf }}/{{ crrParcela }} </label>
    <label class="Times7" style="z-index: 124; left: 425px; position: absolute; top: 475px"> {{ crrEmissao }} </label>
    <label class="Times7B" style="z-index: 125; left: 579px; position: absolute; top: 475px"> {{ crrNossoNumero }} </label>
    <label class="Times7" style="z-index: 126; left: 113px; position: absolute; top: 499px"> {{ dupCarteira }} </label>
    <label class="Times7" style="z-index: 127; left: 185px; position: absolute; top: 499px"> {{ dupMoeda }} </label>
    <label class="Times8B" style="z-index: 128; left: 602px; position: absolute; top: 498px"> {{ crrValorParcela }} </label>
    <div style="z-index: 400; left: 9px; width: 487px; position: absolute; top: 525px; height: 86px; padding-right: 0; 
         padding-left: 0; padding-bottom: 0; margin: 0; border-top-style: none; padding-top: 0; border-right-style: none; border-left-style: none; border-bottom-style: none;">
        <label class="Times8B" v-html="mensDescricao1"></label> <br>
        <label class="Times8B" v-html="mensDescricao2"></label> <br>
        <label class="Times8" v-html="mensVenc"></label>
    </div>
    <span style="z-index: 249; left: 9px; position: absolute; top: 642px;" class="Times7">
         <label> {{ cliCodigo }} </label>-<label> {{ cliCodigoDv }} </label>
        <label>&nbsp; {{ cliRazaoSocial }} </label></span>
    <label style="z-index: 129; left: 9px; position: absolute; top: 653px"
        class="Times7"> {{ cliEndereco }} </label>
    <label style="z-index: 186; left: 385px; position: absolute; top: 643px"
        class="Times7">CPF/CNPJ: {{ cliCnpj }} </label>
    <span class="Times7" style="z-index: 183; left: 385px; position: absolute; top: 654px">CEP:
		<label> {{ cliCep }} </label>
    </span>
    <label style="z-index: 130; left: 522px; position: absolute; top: 643px"
        class="Times7"> {{ cliCidade }} </label>
    <label style="z-index: 131; left: 522px; position: absolute; top: 654px"
        class="Times7"> {{ estUf }} </label>
    <label class="Times10B" style="z-index: 132; left: 281px; position: absolute; top: 400px"> {{ crrLinhaDigitavel }} </label>
    <label class="Times7" style="z-index: 132; left: 257px; position: absolute; top: 475px"> {{ dupEspecie }} </label>
    <label class="Times7" style="z-index: 133; left: 352px; position: absolute; top: 475px">NAO</label>
    &nbsp;
    <!-- Geração de Código de Barras -->
    <!-- <barcode v-bind:value="crrCodBar2" fontOptions='bold' width='2' height='58' text=' ' style="z-index: 1; left: 8px; width: 455px; position: absolute; top: 694px; height: 60px;"></barcode> -->
    <div id="barCode" style="z-index: 251; left: 8px; width: 455px; position: absolute; top: 694px; height: 60px;"> 
            <span v-html="crrCodBar2"></span>
        </div>
    </div>
</template>
<script>

export default {
    name : 'FinancialTicketPayment',
    data() {
        return {
            banco: '',
            crcCupomNf: '',
            crrParcela: '',
            crcCodigo: '',
            cliCodigo: '',
            cliCodigoDv: '',
            crcNumCompra: '', 
            usrCodigo: '', // USR
            crrCodBar2: '',
            crrValorParcela: '',
            bcoCodigo: '',
            crrEmissao: '',
            crrVencimento: '',
            crrLinhaDigitavel: '',
            crrMoraDiaria: '',
            crrAgenciaDuplicata: '',
            crrNossoNumero: '',
            crrTempoProtesto: '',
            bagCodigo: '',
            bccNumConta: '',
            cliRazaoSocial: '',
            cliEndereco: '',
            cliBairro: '',
            cliCep: '',
            cliCidade: '',
            estUf: '',
            cliCnpj: '',
            empFilial: '',
            empCnpj: '',
            empEndereco: '',
            empBairro: '',
            empCidade: '',
            empUf: '',
            dupMoeda: '',
            dupEspecie: '',
            textoProtestar: '',
            mensDescricao1: '',
            mensDescricao2: '',
            mensVenc: '',
            localPgto: '',
            dupCarteira: '',
            dupPreferencia: '',
            beneficiarioEndereco: ''            
        }
    },
    methods: {
        pad: function(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        },
        formatCurrency: function(v) {
            v = v.toString().replace(',','.')
            //formada coluna de valores da tabela para moeda
            var formato = {
                minimumFractionDigits: 2,
                style: "currency",
                currency: "BRL"
            };
            return parseFloat(v).toLocaleString("pt-BR", formato);
        }
    },
    mounted() {
        const self = this
        let xhrBanco = new XMLHttpRequest();
        xhrBanco.onload = () => {
            if (xhrBanco.status == 200)
            {
                let xhr = new XMLHttpRequest()
                xhr.onload = () => {
                    if (xhr.status == 200)
                    {
                        var dadosDuplicata = JSON.parse(xhr.responseText)                        

                        // Preenchendo o Boleto 
                        this.crcCupomNf = this.pad(dadosDuplicata.CRC_CUPOMNF, 10);
                        this.crrParcela = dadosDuplicata.CRR_PARCELA;
                        this.crcCodigo = dadosDuplicata.CRC_CODIGO;                        
                        this.cliCodigo = this.pad(dadosDuplicata.CLI_CODIGO, 6);
                        this.cliCodigoDv = dadosDuplicata.CLI_CODIGODV;
                        this.crcNumCompra = dadosDuplicata.CRC_NUMCOMPRA;
                        this.usrCodigo = dadosDuplicata.USR;                
                        this.crrCodBar2 = dadosDuplicata.CRR_CODBAR2;                
                        this.crrValorParcela = self.formatCurrency(dadosDuplicata.CRR_VALORPARCELA);
                        this.bcoCodigo = dadosDuplicata.BCO_CODIGO;
                        this.crrEmissao = dadosDuplicata.CRR_EMISSAO.substring(0, 10);
                        this.crrVencimento = dadosDuplicata.CRR_VENCIMENTO.replace("00:00:00", '');
                        this.crrLinhaDigitavel = dadosDuplicata.CRR_LINHADIGITAVEL;
                        this.crrMoraDiaria = dadosDuplicata.CRR_MORADIARIA;
                        this.crrAgenciaDuplicata = dadosDuplicata.CRR_AGENCIAPGDUPLICATA;
                        this.crrNossoNumero = dadosDuplicata.CRR_NOSSONUMERO;
                        this.crrTempoProtesto = dadosDuplicata.CRR_TEMPOPROTESTO;
                        this.bagCodigo = dadosDuplicata.BAG_CODIGO;
                        this.bccNumConta = dadosDuplicata.BCC_NUMCONTA;
                        this.cliRazaoSocial = dadosDuplicata.CLI_RAZAOSOCIAL;
                        this.cliEndereco = dadosDuplicata.CLI_ENDERECO;
                        this.cliBairro = dadosDuplicata.CLI_BAIRRO;
                        this.cliCep = dadosDuplicata.CLI_CEP.replace(/(\d{5})(\d{3})/g,"\$1\-\$2");
                        this.cliCidade = dadosDuplicata.CLI_CIDADE;
                        this.estUf = dadosDuplicata.EST_UF;
                        this.cliCnpj = dadosDuplicata.CLI_CICCGC.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
                        
                        this.empFilial = dadosDuplicata.EMP_FILIAL;                
                        this.empCnpj = dadosDuplicata.EMP_CNPJ.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
                        this.empEndereco = dadosDuplicata.EMP_ENDERECO;
                        this.empBairro = dadosDuplicata.EMP_BAIRRO;
                        this.empCidade = dadosDuplicata.EMP_CIDADE;
                        this.empUf = dadosDuplicata.EMP_UF;

                        if (dadosDuplicata.CRR_VENCIMENTO !== ''){
                            let dataStr = this.crrEmissao.split('/')
                            let dataEmissao = new Date(dataStr[2] + "-" + dataStr[1] + "-" + dataStr[0] + "T00:00:00");
                            // // console.log(dataEmissao)

                            if (dataEmissao <= new Date("2010-08-01") || dataEmissao >= new Date("2010-08-04")){
                                this.textoProtestar = "<br/>- Protestar " + this.crrTempoProtesto + " dias após o vencimento.";
                            }
                            else{
                                this.textoProtestar = "<br/>- Sujeito a protesto após o vencimento.";
                            }
                            
                            this.mensDescricao1 = '- Não dispensamos juros ou despesas após o vencimento.<br/>- Cobrar juros de R$' + this.crrMoraDiaria + ' ao dia, após o vencimento.' + this.textoProtestar;
                            this.mensDescricao2 = '- Para duplicatas pagas em cartório, não dispensaremos juros ou despesas. Pague no vencimento.';
                            
                            if (this.bcoCodigo == '399'){
                                this.mensVenc = 'Recebimento através do cheque No. ______________<br/>Esta quitação só tera validade apos pagamento do cheque pelo banco pagador.';
                            }
                        }

                        if (this.bcoCodigo === '1'){
                            this.banco = 'BANCO DO BRASIL'
                            this.bcoCodigo = '001-9'                    

                            this.localPgto = 'Agencia Banco do Brasil&nbsp;&nbsp;' + this.crrAgenciaDuplicata
                            this.dupCarteira = '17-019'
                            this.dupPreferencia = 'PAGAVEL EM QUALQUER BANCO ATE O VENCIMENTO'                    

                            if (this.empFilial == '2'){
                                this.dupMoeda = "R$";
                                this.dupEspecie = "DM";
                            }
                            else{
                                this.dupMoeda = "DM";
                                this.dupEspecie = "Duplicata";
                            }
                        }
                        else if (this.bcoCodigo === '399'){
                            this.banco = 'HSBC'
                            this.bcoCodigo = '399-9'

                            this.localPgto = 'Agencia HSBC&nbsp;&nbsp;' + this.crrAgenciaDuplicata
                            this.dupCarteira = 'CSB'
                            this.dupPreferencia = 'PAGAR PREFERENCIALMENTE EM AGENCIA HSBC'
                            this.dupMoeda = 'R$'
                            this.dupEspecie = 'PD'                    
                        }
                        else if (this.bcoCodigo === '237'){
                            this.banco = "BRADESCO"
                            this.bcoCodigo = '237-2'

                            this.localPgto = 'PAGAR PREFERENCIALMENTE EM AGENCIA BRADESCO OU BRADESCO EXPRESSO'
                            this.dupCarteira = '09'
                            this.dupMoeda = 'R$'
                            this.dupEspecie = 'DM'
                        }

                        this.beneficiarioEndereco = 'Descarbonize Soluções S/A CNPJ:' + this.empCnpj + ' ENDEREÇO:' + this.empEndereco.replace("  ", " ") + ' - BAIRRO:' 
                                                    + this.empBairro + ' - CIDADE:' + this.empCidade + ' - ' + this.empUf.toUpperCase()   

                    }
                    else if (xhr.status == 401)
                    {
                        swal({
                            title: "É necessário estar logado",
                            icon: "warning"
                        }).then(() => location.href = `${self.$SiteUrl}/login`)
                    }
                }

                xhr.open("POST", this.$apiUrl + "Financeiro.svc/dadosduplicata")
                xhr.setRequestHeader("Content-type", "application/json")
                xhr.withCredentials = true
                xhr.send(JSON.stringify({
                    crcCupomNf: this.$route.params.crc_cupomnf,
                    crrParcela: this.$route.params.crr_parcela,
                    crcSerieNf: this.$route.params.crc_serienf
                }))
            }
            else if (xhrBanco.status == 401){
                swal({
                    title: "É necessário estar logado",
                    icon: "warning"
                }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=${location.href}`)
            }
            else if (xhrBanco.status == 404){
                swal({
                    title: "Duplicata não enviada ao Banco ou inexistente!",
                    icon: "warning"
                }).then(() => location.href = `${self.$SiteUrl}/Financeiro/boleto`)
            }
        }  
        
        xhrBanco.open("POST", this.$apiUrl + "Financeiro.svc/enviarbanco");
        xhrBanco.setRequestHeader("Content-type", "application/json")
        xhrBanco.withCredentials = true;
        xhrBanco.send(JSON.stringify({
            crcCupomNf: this.$route.params.crc_cupomnf,
            crcSerieNf: this.$route.params.crc_serienf
        }))
    }  
}
</script>
